<div class="ha-how-you-sleep-section section-wrapper">
	<div id="lifestyle-how-you-sleep">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.heading'">How You Sleep</span>
		</div>
		<div class="form-group" [formGroup]="howYouSleepForm">
			<div>
				<div
					class="radio-btn-label"
					[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.hoursOfSleep'">
					Over the last two weeks, how many hours of sleep did you average in a 24-hour period?
				</div>
				<div class="slider-show-value-text">
					<div class="slider-labels">
						<span class="label-value-text">
							{{ !howYouSleepData.hoursOfSleep ? '1' : howYouSleepForm.get('hoursOfSleep').value }}
						</span>
					</div>
					<mat-slider
						appAutofocus
						[disabled]="readOnly"
						[max]="max"
						[min]="min"
						[step]="step"
						[discrete]="showThumbLabel"
						[showTickMarks]="showTickMarks">
						<input matSliderThumb formControlName="hoursOfSleep" [(ngModel)]="howYouSleepData.hoursOfSleep" />
					</mat-slider>
				</div>
				<div>
					<div class="question-wrapper form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.satisfiedWithSleep'">
							How satisfied are you with your current sleep pattern?
						</div>
						<mat-radio-group
							[(ngModel)]="howYouSleepData.satisfiedWithSleep"
							formControlName="satisfiedWithSleep"
							[disabled]="readOnly">
							<mat-radio-button [value]="condition.id" *ngFor="let condition of satisfiedWithSleepValues">
								<span>{{ condition.name }}</span>
							</mat-radio-button>
						</mat-radio-group>
					</div>

					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.difficultySleeping'">
							Do you have difficulty sleeping?
						</div>
						<mat-radio-group
							formControlName="difficultySleeping"
							(change)="difficultySleepingRadio($event)"
							[disabled]="readOnly">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>
					<div class="form-field" *ngIf="difficultySleeping">
						<div class="checkbox-list" *ngFor="let condition of difficultyWithSleepValues">
							<mat-checkbox
								*ngIf="!condition.hideCheckbox"
								(change)="difficultyWithSleepSelection(condition)"
								[checked]="condition.checked"
								[disabled]="readOnly"
								>{{ condition.name }}</mat-checkbox
							>
						</div>
					</div>

					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.feelTired'">
							During the last two weeks, how often did you feel tired or have difficulty staying awake during routine
							tasks in the day?
						</div>
						<mat-form-field appearance="fill">
							<mat-label
								><span
									[translate]="
										'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.feelTired-placeholder'
									">
									During the last two weeks, how often did you feel tired or have difficulty staying awake during
									routine tasks in the day?
								</span></mat-label
							>
							<input matInput formControlName="feelTired" [readonly]="readOnly" />
						</mat-form-field>
					</div>

					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.sufferJetLag'">
							Do you suffer jet lag?
						</div>
						<mat-radio-group formControlName="sufferJetLag" [disabled]="readOnly">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>

					<div class="form-field">
						<div
							class="radio-btn-label"
							[translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.nightShifts'">
							Do you have a job that requires night shifts?
						</div>
						<mat-radio-group name="nightShifts" formControlName="nightShifts" [disabled]="readOnly">
							<mat-radio-button [value]="true">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-yes'"
									>Yes</span
								>
							</mat-radio-button>
							<mat-radio-button [value]="false">
								<span [translate]="'wellness.health-assessment-new.lifestyle.how-you-sleep.form-fields.option-no'"
									>No</span
								>
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button>
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
